import i18n from "@/i18n";
import getRouter from "@/router";
import store from "@/store";
import vuetify from "@/vuetify";
import Vue from "vue";
import { useOverride } from "@/lib/helpers/i18nHelper";
import routerHooks from "@/router/globalHooks";

useOverride();

Vue.config.devtools = true;

export function createApp() {
  const router = getRouter(Vue);
  Vue.use(routerHooks, { router, store });
  return new Vue({
    router,
    store,
    render: h => h(require("./App.vue").default),
    i18n,
    vuetify,
  }).$mount("#app");
}
